// ====== إعدادات الـ SEO المشتركة ======
export const SITE_URL = "https://alnjoom.sa";
export const DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية

// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash
const normalizePath = (asPath = "/") => {
  let path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = `/${path}`;
  // مطابقة لإعداد trailingSlash: true في next.config.js
  if (path !== "/" && !path.endsWith("/")) path = `${path}/`;
  return path;
};

// يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)
export const localizedUrl = (asPath, locale) => {
  const path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"
  if (locale === DEFAULT_LOCALE) return `${SITE_URL}${path}`;
  return path === "/" ? `${SITE_URL}/${locale}/` : `${SITE_URL}/${locale}${path}`;
};

// يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية
export const buildSeoAlternates = (asPath, currentLocale = DEFAULT_LOCALE) => ({
  canonical: localizedUrl(asPath, currentLocale),
  languageAlternates: [
    { hrefLang: "ar", href: localizedUrl(asPath, "ar") },
    { hrefLang: "en", href: localizedUrl(asPath, "en") },
    { hrefLang: "x-default", href: localizedUrl(asPath, DEFAULT_LOCALE) },
  ],
});
